import React from 'react';

import { useSettingsPanel } from './use-settings-panel';

type SettingsPanelContext = ReturnType<typeof useSettingsPanel> | null;

const SettingsPanelContext = React.createContext<SettingsPanelContext>(null);

const useSettingsPanelState = () => {
  const context = React.useContext(SettingsPanelContext);

  if (context == null) {
    throw new Error('Component must be wrapped in <SettingsPanel />.');
  }

  return context;
};

export { SettingsPanelContext, useSettingsPanelState };
